// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"03bd6d6f","836":"ef4559d3"}[chunkId] + ".chunk.css";
};